import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingInvoiceStatistics } from "@msuite/utils/types";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useIncomingInvoiceStatistics() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	// The dashboard sits behind `read IncomingInvoice` in the navigation; waiting for the rule
	// spares a caller who typed the address the 403 toast.
	const query = useQuery({
		queryKey: ["incoming-invoices", "statistics"],
		enabled: citadel?.can("read", "IncomingInvoice") === true,
		queryFn: async () => {
			const response = await client.incoming_invoices.statistics.$get();
			const data = await responseHandler(response);
			return data.statistics as IncomingInvoiceStatistics;
		},
	});

	/** Return */
	return { ...query, statistics: query.data };
}
